import { createSlice } from "@reduxjs/toolkit";

const initialAppSettingsState = {
  settingsDropdownItems: [],
  loadingAppSettings: true,
};

const appSettings = createSlice({
  name: "appSettings",
  initialState: initialAppSettingsState,
  reducers: {
    setAppSettings(state, action) {
      state.loadingAppSettings = false;
      state.settingsDropdownItems = action.payload.settingsDropdownItems;
    },
  },
});

export const appSettingsActions = appSettings.actions;
export default appSettings.reducer;
